<template>
  <button
    class="like-button"
    type="button"
    :class="{ active }"
    v-on="$listeners">
    <MaterialIcon
      icon="thumb_up"
      class="mr-1" />
    <span>
      <slot>
        いいね
      </slot>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
.like-button {
  display: flex;
  align-items: center;
  color: $grey05;
  font-size: 16px;

  border: none;
  background-color: transparent;
  
  &.active {
    color: $l-blue;
  }
}
</style>